import * as React from 'react';
import * as Styled from './checkbox.styles';
export const Checkbox = ({ className, disabled, error, name, on, onChange, ...props }) => (React.createElement(Styled.Container, { className: className },
    React.createElement(Styled.Checkbox, { "$error": error, checked: on, "data-xds": "Checkbox", disabled: disabled, name: name, onChange: onChange, type: "checkbox", ...props }),
    React.createElement(Styled.Tick, { width: 24, height: 24 })));
Checkbox.displayName = 'Checkbox';
//# sourceMappingURL=checkbox.js.map